"use strict";
var ACC;
ACC.cartitem = {

    _autoload: [
        "bindCartItem",
        ["cartEmptyAction", ($(".page-cartPage").length && $(".empty-basket").length)]
    ],

    bindCartItem: function () {

        $('.remove-entry-button').on("click", function () {
            var globalStorage = JSON.parse(localStorage.getItem('gtm.global') || '{}');
            var removedItem = globalStorage.basket.lineItems.filter(function (item) {
                return item.dimension4 === productCode;
            });
            var entryNumber = $(this).attr('id').split("_")[1];
            var formName = 'updateCartForm' + entryNumber;
            var form = $('#' + formName);
            var csrfTokenInput = form.find('input[name="CSRFToken"]');
            var bundleID = $(this).data('productBundleid');

            form.find('input[name=initialQuantity]').val('0');
            var quantityElement = form.find('#quantity_' + entryNumber);
            quantityElement.prepend('<option value="0"></option>');
            quantityElement.val('0');

            var productCode = form.find('input[name=productCode]').val();

            ACC.config.CSRFToken = ACC.common.getCSRFTokenJS();
			csrfTokenInput.val(ACC.config.CSRFToken);

            // form.submit will be called here after the event is tracked
            ACC.gtm.trackRemoveFromCart(productCode, '', formName, removedItem, bundleID);
        });

        $('.update-entry-quantity-input').on("change", function () {
            var entryNumber = $(this).attr('id').split("_"),
                form = $('#updateCartForm' + entryNumber[1]);

            var csrfTokenInput = form.find('input[name="CSRFToken"]');

            var productCode = form.find('input[name=productCode]').val(),
                initialCartQuantity = form.find('input[name=initialQuantity]').val(),
                newCartQuantity = form.find('.selectric .label').text();

            if (initialCartQuantity !== newCartQuantity) {
                ACC.common.removeFromLocalStorage(ACC.common.localCartJsonKey);
                ACC.gtm.trackQuantitySelectCart(productCode, newCartQuantity, '', '');
                //ACC.track.trackUpdateCart(productCode, initialCartQuantity, newCartQuantity);

                ACC.config.CSRFToken = ACC.common.getCSRFTokenJS();
			    csrfTokenInput.val(ACC.config.CSRFToken);

                form.submit();
            }

        });
    },

    // Returns true/false to show if cart empty.
    cartEmpty: function () {
        return $("input[name='productCode']").length < 1;
    },

    // Empty cart adjustments.
    // 1. Clears any persisted CandC store selection.
    cartEmptyAction: function () {
        if (ACC.cartitem.cartEmpty()) {
            ACC.checkoutsteps.clearSelectedStore();
        }
    }
};

